import React from 'react';
import { Currency } from 'ui-toolkit';
import { SpaEscrowExpectedHeader } from './SpaEscrowExpectedHeader';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export interface IEscrowExpectedHeaderContainerProps {
  escrowBalancesHeaderSlice: any;
  orderData: IOrderDetailsData;
}

export const SpaEscrowExpectedHeaderContainer: React.FC<IEscrowExpectedHeaderContainerProps> = ({
  escrowBalancesHeaderSlice,
  orderData,
}) => {
  const {
    expectedBorrowerCashToCloseAmountDollars,
    expectedBuyerCashToCloseAmountDollars,
    expectedIncomingLenderAmountDollars,
  } = escrowBalancesHeaderSlice.data;

  return (
    <SpaEscrowExpectedHeader
      expectedBorrowerCash={
        (expectedBorrowerCashToCloseAmountDollars < 0 && (
          <Currency value={expectedBorrowerCashToCloseAmountDollars * -1} />
        )) ||
        '--'
      }
      expectedBuyerCash={
        (expectedBuyerCashToCloseAmountDollars > 0 && <Currency value={expectedBuyerCashToCloseAmountDollars} />) ||
        '--'
      }
      expectedLenderCash={<Currency value={expectedIncomingLenderAmountDollars} />}
      loanAmount={orderData.transaction.loan_amount}
      transactionCategory={orderData.transaction.transaction_category}
    />
  );
};
